<script>
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import _ from 'lodash';

export default {
  name: 'ProgressPhotos',
  components: {},
  props: {
    progressPhotos: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  mixins: [breakpointsMixin],
  data() {
    return {
      fileType: null,
      capturingPhoto: false,
      imageCaptured: null,
      imageBlob: null,
      mediaStream: null,
      countDownNum: 3,
      deviceHasCamera: false,
    };
  },
  async mounted() {
    await this.checkDeviceCamera(); // Here we check if the device has camera, if yes request access.
  },
  methods: {
    uploadImg(e, type) {
      // This to display temp photo and update progressPhotos object on the parent component
      const progressPhotosClone = _.cloneDeep(this.progressPhotos);
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        progressPhotosClone[type] = {
          file: file,
          temp: evt.target.result,
        };
        this.$emit('set-progress-photos-props', progressPhotosClone);
      };
    },
    deleteImg(type) {
      // Rempove temp photo
      const progressPhotosClone = _.cloneDeep(this.progressPhotos);
      progressPhotosClone[type] = null;
      this.$emit('set-progress-photos-props', progressPhotosClone);
    },
    openInput(type) {
      // This will check if we still have access to cam then open it otherwise open the file
      this.fileType = type;
      navigator.getUserMedia =
        navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

      if (this.isDesktopView) {
        // Do desktop cam access a otherwisw open mobile cam from input element
        if (navigator) {
          if (navigator.permissions && navigator.getUserMedia) {
            // This for chrome and other browseres exept safari
            navigator.permissions // Safari does not have permissions so we'll have to do it different
              .query({ name: 'camera' }) // Grab camera status
              .then((status) => {
                if (status && status.state && (status.state === 'prompt' || status.state === 'granted')) {
                  // Good to use
                  navigator.getUserMedia =
                    navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia ||
                    navigator.msGetUserMedia ||
                    navigator.mediaDevices.getUserMedia;

                  if (navigator && navigator.getUserMedia) {
                    navigator.getUserMedia =
                      navigator.getUserMedia ||
                      navigator.webkitGetUserMedia ||
                      navigator.mozGetUserMedia ||
                      navigator.msGetUserMedia ||
                      navigator.mediaDevices.getUserMedia;
                    navigator.getUserMedia({ video: true }, this.handleCamera, this.handleNoCamera); // Get the stream from our webcam
                  } else {
                    this.handleNoCamera(this.fileType); // If anything goes wrong then handle by opening file input
                  }
                } else {
                  this.handleNoCamera(this.fileType); // If anything goes wrong then handle by opening file input
                }
              })
              .catch(() => {
                this.handleNoCamera(this.fileType); // If anything goes wrong then handle by opening file input
              });
          } else {
            if (navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
              // This mostly for safari
              navigator.mediaDevices
                .getUserMedia({ video: true })
                .then((stream) => {
                  this.handleCamera(stream); // Permission granted (user clicked allow)
                })
                .catch((e) => {
                  this.handleNoCamera(this.fileType); // User didn't allow using cam
                });
            } else {
              this.handleNoCamera(this.fileType); // If anything goes wrong then handle by opening file input
            }
          }
        }
      } else {
        this.handleNoCamera(this.fileType, 'mobileCam'); // Go ahead and open mobile cam because above code won't work for mobile
      }
    },
    async checkDeviceCamera() {
      // This will run every time component mounts
      navigator.getUserMedia =
        navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if (this.isDesktopView && navigator) {
        // Desktop check
        if (navigator.permissions && navigator.getUserMedia) {
          // Non safari
          try {
            const camStatus = await navigator.permissions.query({ name: 'camera' });
            if (camStatus && camStatus.state && (camStatus.state === 'prompt' || camStatus.state === 'granted')) {
              if (navigator && navigator.getUserMedia) {
                await navigator.getUserMedia(
                  { video: true },
                  (stream) => {
                    // User allow then all set but make sure to stop the video streaming
                    const tracks = stream.getTracks();
                    tracks.map((track) => track.stop());
                    this.deviceHasCamera = true;
                  },
                  () => {
                    // User didn't allow then don't display cam icon
                    this.deviceHasCamera = false;
                  }
                );
              } else {
                // If anything goes wrong then don't display cam icon
                this.deviceHasCamera = false;
              }
            } else {
              // If anything goes wrong then don't display cam icon
              this.deviceHasCamera = false;
            }
          } catch (e) {
            // If anything goes wrong then don't display cam icon
            this.deviceHasCamera = false;
          }
        } else {
          if (navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            // Safari code
            navigator.mediaDevices
              .getUserMedia({ video: true })
              .then((stream) => {
                // User allow then all set but make sure to stop the video streaming
                const tracks = stream.getTracks();
                tracks.map((track) => track.stop());
                this.deviceHasCamera = true;
              })
              .catch((e) => {
                this.deviceHasCamera = false; // User didn't allow then don't display cam icon
              });
          } else {
            this.deviceHasCamera = false; // If anything goes wrong then don't display cam icon
          }
        }
      } else {
        // It's mobile then true
        this.deviceHasCamera = true;
      }
    },
    handleCamera(stream) {
      // Mount the stream to our video element
      this.capturingPhoto = true;
      this.$refs.video.srcObject = stream;
      this.mediaStream = stream;
      this.$refs.video.play(); // Play it
    },
    handleNoCamera(type, action) {
      this.fileType = type;
      if (action && action === 'mobileCam') {
        // If we're using input to open mobile cam then we'll have to add capture prop
        switch (type) {
          case 'front':
            this.$refs.fileInputFront.setAttribute('capture', 'camera');
            break;
          case 'back':
            this.$refs.fileInputBack.setAttribute('capture', 'camera');
            break;
          case 'side':
            this.$refs.fileInputSide.setAttribute('capture', 'camera');
            break;
        }
      } else {
        switch (
          type // Otherwise remove capture so we can open files on mobile using the same elelemt
        ) {
          case 'front':
            this.$refs.fileInputFront.removeAttribute('capture');
            break;
          case 'back':
            this.$refs.fileInputBack.removeAttribute('capture');
            break;
          case 'side':
            this.$refs.fileInputSide.removeAttribute('capture');
            break;
        }
      }
      switch (
        type // Open the thing
      ) {
        case 'front':
          this.$refs.fileInputFront.click();
          break;
        case 'back':
          this.$refs.fileInputBack.click();
          break;
        case 'side':
          this.$refs.fileInputSide.click();
          break;
      }
      this.fileType = null;
    },
    capture() {
      // This is when we capture on desktop
      const countDown = setInterval(() => {
        // Count from 3 to 0
        this.countDownNum--;
      }, 1000);
      setTimeout(() => {
        clearInterval(countDown);
        this.countDownNum = 0;
        if ('ImageCapture' in window) {
          // Non safari
          const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
          const imageCapture = new window.ImageCapture(mediaStreamTrack);
          return imageCapture.takePhoto().then((blob) => {
            this.imageCaptured = URL.createObjectURL(blob);
            this.imageBlob = blob;
          });
        } else {
          // We handle fallback because safari doesn't have ImageCapture so we'll have to draw and capture
          this.getBlobFromHtmlCanvas(this.mediaStream).then((blob) => {
            this.imageCaptured = URL.createObjectURL(blob);
            this.imageBlob = blob;
          });
        }
      }, 3000);
    },
    getBlobFromHtmlCanvas(stream) {
      // Drawing the image and convert to blob to be able to use just like ImageCapture when return's a blob
      const video = document.createElement('video');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      video.srcObject = stream;
      return new Promise((resolve, reject) => {
        video.addEventListener('loadeddata', async () => {
          // When video ready
          const { videoWidth, videoHeight } = video; // Take dimentions
          canvas.width = videoWidth;
          canvas.height = videoHeight;
          try {
            await video.play(); // Play but everything is internally
            context.drawImage(video, 0, 0, videoWidth, videoHeight); // Draw it to a canvas
            canvas.toBlob(resolve, 'image/png'); // Get the blob and return it to out capture method
          } catch (error) {
            reject(error);
          }
        });
      });
    },
    reTake() {
      // Reset and open again
      this.countDownNum = 3;
      this.imageCaptured = null;
      this.openInput(this.fileType);
    },
    done() {
      // When user accepts the image captured
      const progressPhotosClone = _.cloneDeep(this.progressPhotos);
      const fileType = this.fileType;
      const file = new File([this.imageBlob], fileType);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      // Prep image file and temp image to display
      reader.onload = (evt) => {
        progressPhotosClone[fileType] = {
          // We add url and file in the same flag so we can display the temporary image and use the other to upload
          file: file,
          temp: evt.target.result,
        };
        this.$emit('set-progress-photos-props', progressPhotosClone);
      };
      const tracks = this.mediaStream.getTracks(); // Also stop the stream
      tracks.map((track) => track.stop());
      this.fileType = null; // And reset all data to start over
      this.capturingPhoto = false;
      this.imageCaptured = null;
      this.imageBlob = null;
      this.mediaStream = null;
      this.countDownNum = 3;
    },
  },
  computed: {
    front() {
      return this.progressPhotos && this.progressPhotos.front && this.progressPhotos.front.temp;
    },
    back() {
      return this.progressPhotos && this.progressPhotos.back && this.progressPhotos.back.temp;
    },
    side() {
      return this.progressPhotos && this.progressPhotos.side && this.progressPhotos.side.temp;
    },
    uploadBottom() {
      // Because of the absolute position we will want to to calculate our bottom position with JS
      return (
        document.getElementsByClassName('page') &&
        document.getElementsByClassName('page').length > 0 &&
        document.getElementsByClassName('page')[0] &&
        document.getElementsByClassName('page')[0].getBoundingClientRect() &&
        document.getElementsByClassName('page')[0].getBoundingClientRect().y - (this.isDesktopView ? 35 : 15)
      );
    },
  },
};
</script>

<template>
  <div class="page">
    <div class="images-view">
      <BaseProgressBar class="base-progress-bar" :limit="2" :progress="2" />
      <div v-show="!capturingPhoto" class="container">
        <div class="header">
          <div class="title"> <h1>It’s time to take your baseline photos.</h1>{{ deviceHasCamera }}{{ isDesktopView }} </div>
          <div class="subtitle">
            <p>
              Use the camera to take your front, back and side body shots.
            </p>
          </div>
        </div>
        <div class="form">
          <form>
            <div class="photos">
              <div @click="$emit('finish', 'skip')" class="skip row">
                Skip
                <svg width="29" height="11" viewBox="0 0 29 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 5.34762C0.0634336 5.16677 0.186103 5.01163 0.348845 4.90644C0.511588 4.80125 0.705241 4.75192 0.899555 4.76618C4.47604 4.7792 22.4181 4.77305 25.9917 4.77305H26.3788C26.1891 4.55609 26.055 4.38795 25.9029 4.235C25.3309 3.66223 24.7538 3.09296 24.1716 2.52719C23.84 2.20175 23.4956 1.89078 23.1711 1.5592C22.9829 1.39379 22.8268 1.19631 22.7103 0.976307C22.5463 0.591209 22.7876 0.222381 23.2938 0H23.5582C23.9182 0.174262 24.2337 0.425746 24.4814 0.735846C24.9831 1.21134 25.4708 1.69624 25.9589 2.18403C26.2982 2.52357 26.622 2.8783 26.9623 3.2153C27.4357 3.68067 27.923 4.1323 28.399 4.59478C28.5986 4.75242 28.7716 4.93999 28.9117 5.15056C28.9961 5.31254 29.021 5.49817 28.9821 5.67606C28.9431 5.85395 28.8428 6.01319 28.6981 6.12686C28.1278 6.66226 27.563 7.20345 27.0036 7.75042C26.5288 8.21579 26.0709 8.69671 25.6008 9.16606C25.1944 9.5737 24.7843 9.97579 24.3705 10.3723C24.1913 10.5491 24.0009 10.7144 23.8003 10.8674C23.7298 10.9206 23.6491 10.9591 23.5629 10.9805C23.4768 11.0019 23.3871 11.0057 23.2993 10.9918C23.2116 10.9779 23.1277 10.9465 23.0528 10.8995C22.9779 10.8526 22.9136 10.791 22.8639 10.7187C22.5213 10.3242 22.5872 10.0104 23.0072 9.60251C23.5844 9.03951 24.1428 8.45662 24.7179 7.89144C25.1094 7.50779 25.5198 7.14439 25.9136 6.76037C26.0609 6.61754 26.1869 6.4541 26.3792 6.23534H26.0285C22.4417 6.23534 4.48967 6.22991 0.903976 6.24221C0.70945 6.25686 0.515477 6.20766 0.352523 6.10236C0.189569 5.99705 0.0668665 5.84159 0.00368447 5.6604L0 5.34762Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div class="photos-wrapper row">
                <div class="col">
                  <div class="img">
                    <div class="remove" v-if="front" @click="deleteImg('front')">
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.94414 4.50002L0.0791016 7.36506L1.63474 8.9207L4.49978 6.05566L7.36482 8.9207L8.92045 7.36506L6.05541 4.50002L8.92045 1.63498L7.36482 0.0793457L4.49978 2.94439L1.63474 0.0793457L0.0791016 1.63498L2.94414 4.50002Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <img v-if="front" :src="front" />
                    <div class="upload" v-if="!front">
                      <div v-if="deviceHasCamera" @click="openInput('front')">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.6553 1.82197H9.76315L8.67082 0.628174H5.08943L3.9971 1.82197H2.10493C1.78832 1.82197 1.48467 1.94775 1.26079 2.17163C1.03691 2.39551 0.911133 2.69916 0.911133 3.01577V10.1786C0.911133 10.4952 1.03691 10.7988 1.26079 11.0227C1.48467 11.2466 1.78832 11.3724 2.10493 11.3724H11.6553C11.9719 11.3724 12.2756 11.2466 12.4995 11.0227C12.7233 10.7988 12.8491 10.4952 12.8491 10.1786V3.01577C12.8491 2.69916 12.7233 2.39551 12.4995 2.17163C12.2756 1.94775 11.9719 1.82197 11.6553 1.82197ZM11.6553 10.1786H2.10493V3.01577H4.52237L5.6147 1.82197H8.14555L9.23788 3.01577H11.6553V10.1786ZM6.88013 3.61267C6.08859 3.61267 5.32947 3.92711 4.76977 4.48681C4.21007 5.04651 3.89563 5.80563 3.89563 6.59717C3.89563 7.3887 4.21007 8.14782 4.76977 8.70752C5.32947 9.26723 6.08859 9.58166 6.88013 9.58166C7.67166 9.58166 8.43078 9.26723 8.99048 8.70752C9.55019 8.14782 9.86462 7.3887 9.86462 6.59717C9.86462 5.80563 9.55019 5.04651 8.99048 4.48681C8.43078 3.92711 7.67166 3.61267 6.88013 3.61267ZM6.88013 8.38786C6.4052 8.38786 5.94973 8.1992 5.61391 7.86338C5.27809 7.52756 5.08943 7.07209 5.08943 6.59717C5.08943 6.12224 5.27809 5.66677 5.61391 5.33095C5.94973 4.99513 6.4052 4.80647 6.88013 4.80647C7.35505 4.80647 7.81052 4.99513 8.14634 5.33095C8.48216 5.66677 8.67082 6.12224 8.67082 6.59717C8.67082 7.07209 8.48216 7.52756 8.14634 7.86338C7.81052 8.1992 7.35505 8.38786 6.88013 8.38786Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span @click="handleNoCamera('front')" :class="{ noCam: !deviceHasCamera }">Upload</span>
                      <input
                        capture="camera"
                        type="file"
                        name="uploadfile"
                        ref="fileInputFront"
                        :style="{ display: 'none' }"
                        accept="image/x-png,image/gif,image/jpeg"
                        @change.prevent="uploadImg($event, 'front')"
                      />
                    </div>
                  </div>
                  <span :class="{ haveImg: front }">Front</span>
                </div>
                <div class="col">
                  <div class="img">
                    <div class="remove" v-if="back" @click="deleteImg('back')">
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.94414 4.50002L0.0791016 7.36506L1.63474 8.9207L4.49978 6.05566L7.36482 8.9207L8.92045 7.36506L6.05541 4.50002L8.92045 1.63498L7.36482 0.0793457L4.49978 2.94439L1.63474 0.0793457L0.0791016 1.63498L2.94414 4.50002Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <img v-if="back" :src="back" />
                    <div class="upload" v-if="front && !back">
                      <div v-if="deviceHasCamera" @click="openInput('back')">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.6553 1.82197H9.76315L8.67082 0.628174H5.08943L3.9971 1.82197H2.10493C1.78832 1.82197 1.48467 1.94775 1.26079 2.17163C1.03691 2.39551 0.911133 2.69916 0.911133 3.01577V10.1786C0.911133 10.4952 1.03691 10.7988 1.26079 11.0227C1.48467 11.2466 1.78832 11.3724 2.10493 11.3724H11.6553C11.9719 11.3724 12.2756 11.2466 12.4995 11.0227C12.7233 10.7988 12.8491 10.4952 12.8491 10.1786V3.01577C12.8491 2.69916 12.7233 2.39551 12.4995 2.17163C12.2756 1.94775 11.9719 1.82197 11.6553 1.82197ZM11.6553 10.1786H2.10493V3.01577H4.52237L5.6147 1.82197H8.14555L9.23788 3.01577H11.6553V10.1786ZM6.88013 3.61267C6.08859 3.61267 5.32947 3.92711 4.76977 4.48681C4.21007 5.04651 3.89563 5.80563 3.89563 6.59717C3.89563 7.3887 4.21007 8.14782 4.76977 8.70752C5.32947 9.26723 6.08859 9.58166 6.88013 9.58166C7.67166 9.58166 8.43078 9.26723 8.99048 8.70752C9.55019 8.14782 9.86462 7.3887 9.86462 6.59717C9.86462 5.80563 9.55019 5.04651 8.99048 4.48681C8.43078 3.92711 7.67166 3.61267 6.88013 3.61267ZM6.88013 8.38786C6.4052 8.38786 5.94973 8.1992 5.61391 7.86338C5.27809 7.52756 5.08943 7.07209 5.08943 6.59717C5.08943 6.12224 5.27809 5.66677 5.61391 5.33095C5.94973 4.99513 6.4052 4.80647 6.88013 4.80647C7.35505 4.80647 7.81052 4.99513 8.14634 5.33095C8.48216 5.66677 8.67082 6.12224 8.67082 6.59717C8.67082 7.07209 8.48216 7.52756 8.14634 7.86338C7.81052 8.1992 7.35505 8.38786 6.88013 8.38786Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span @click="handleNoCamera('back')" :class="{ noCam: !deviceHasCamera }">Upload</span>
                      <input
                        capture="camera"
                        type="file"
                        name="uploadfile"
                        ref="fileInputBack"
                        :style="{ display: 'none' }"
                        accept="image/x-png,image/gif,image/jpeg"
                        @change.prevent="uploadImg($event, 'back')"
                      />
                    </div>
                  </div>
                  <span :class="{ haveImg: back }">Back</span>
                </div>
                <div class="col">
                  <div class="img">
                    <div class="remove" v-if="side" @click="deleteImg('side')">
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.94414 4.50002L0.0791016 7.36506L1.63474 8.9207L4.49978 6.05566L7.36482 8.9207L8.92045 7.36506L6.05541 4.50002L8.92045 1.63498L7.36482 0.0793457L4.49978 2.94439L1.63474 0.0793457L0.0791016 1.63498L2.94414 4.50002Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <img v-if="side" :src="side" />
                    <div class="upload" v-if="front && back && !side">
                      <div v-if="deviceHasCamera" @click="openInput('side')">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.6553 1.82197H9.76315L8.67082 0.628174H5.08943L3.9971 1.82197H2.10493C1.78832 1.82197 1.48467 1.94775 1.26079 2.17163C1.03691 2.39551 0.911133 2.69916 0.911133 3.01577V10.1786C0.911133 10.4952 1.03691 10.7988 1.26079 11.0227C1.48467 11.2466 1.78832 11.3724 2.10493 11.3724H11.6553C11.9719 11.3724 12.2756 11.2466 12.4995 11.0227C12.7233 10.7988 12.8491 10.4952 12.8491 10.1786V3.01577C12.8491 2.69916 12.7233 2.39551 12.4995 2.17163C12.2756 1.94775 11.9719 1.82197 11.6553 1.82197ZM11.6553 10.1786H2.10493V3.01577H4.52237L5.6147 1.82197H8.14555L9.23788 3.01577H11.6553V10.1786ZM6.88013 3.61267C6.08859 3.61267 5.32947 3.92711 4.76977 4.48681C4.21007 5.04651 3.89563 5.80563 3.89563 6.59717C3.89563 7.3887 4.21007 8.14782 4.76977 8.70752C5.32947 9.26723 6.08859 9.58166 6.88013 9.58166C7.67166 9.58166 8.43078 9.26723 8.99048 8.70752C9.55019 8.14782 9.86462 7.3887 9.86462 6.59717C9.86462 5.80563 9.55019 5.04651 8.99048 4.48681C8.43078 3.92711 7.67166 3.61267 6.88013 3.61267ZM6.88013 8.38786C6.4052 8.38786 5.94973 8.1992 5.61391 7.86338C5.27809 7.52756 5.08943 7.07209 5.08943 6.59717C5.08943 6.12224 5.27809 5.66677 5.61391 5.33095C5.94973 4.99513 6.4052 4.80647 6.88013 4.80647C7.35505 4.80647 7.81052 4.99513 8.14634 5.33095C8.48216 5.66677 8.67082 6.12224 8.67082 6.59717C8.67082 7.07209 8.48216 7.52756 8.14634 7.86338C7.81052 8.1992 7.35505 8.38786 6.88013 8.38786Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span @click="handleNoCamera('side')" :class="{ noCam: !deviceHasCamera }">Upload</span>
                      <input
                        capture="camera"
                        type="file"
                        name="uploadfile"
                        ref="fileInputSide"
                        :style="{ display: 'none' }"
                        accept="image/x-png,image/gif,image/jpeg"
                        @change.prevent="uploadImg($event, 'side')"
                      />
                    </div>
                  </div>
                  <span :class="{ haveImg: side }">Side</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-show="!capturingPhoto" class="buttons">
        <div id="back">
          <BaseButton class="large-transparent" @click="$emit('back')">
            <img src="@assets/images/icons/left-arrow.svg" />
            Back
          </BaseButton>
        </div>
        <div id="next">
          <BaseButton class="large" @click="$emit('finish', 'finish')">
            Finish
            <img src="@assets/images/icons/right-arrow.svg" />
          </BaseButton>
        </div>
      </div>
    </div>
    <div v-show="capturingPhoto" :class="['images-view-camera']">
      <video v-if="!imageCaptured" ref="video" class="camera-stream" />
      <img v-if="imageCaptured" :src="imageCaptured" class="camera-stream" />
      <div class="actions">
        <span v-if="!imageCaptured">
          {{
            countDownNum && countDownNum === 3
              ? countDownNum
              : countDownNum === 2
              ? `3...${countDownNum}`
              : countDownNum === 1
              ? `3...2...${countDownNum}`
              : `Hold`
          }}</span
        >
        <div v-show="imageCaptured">
          <BaseButton class="button btn-secondary btn-round btn-add-more" @click="reTake"
            ><svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.6553 1.82197H9.76315L8.67082 0.628174H5.08943L3.9971 1.82197H2.10493C1.78832 1.82197 1.48467 1.94775 1.26079 2.17163C1.03691 2.39551 0.911133 2.69916 0.911133 3.01577V10.1786C0.911133 10.4952 1.03691 10.7988 1.26079 11.0227C1.48467 11.2466 1.78832 11.3724 2.10493 11.3724H11.6553C11.9719 11.3724 12.2756 11.2466 12.4995 11.0227C12.7233 10.7988 12.8491 10.4952 12.8491 10.1786V3.01577C12.8491 2.69916 12.7233 2.39551 12.4995 2.17163C12.2756 1.94775 11.9719 1.82197 11.6553 1.82197ZM11.6553 10.1786H2.10493V3.01577H4.52237L5.6147 1.82197H8.14555L9.23788 3.01577H11.6553V10.1786ZM6.88013 3.61267C6.08859 3.61267 5.32947 3.92711 4.76977 4.48681C4.21007 5.04651 3.89563 5.80563 3.89563 6.59717C3.89563 7.3887 4.21007 8.14782 4.76977 8.70752C5.32947 9.26723 6.08859 9.58166 6.88013 9.58166C7.67166 9.58166 8.43078 9.26723 8.99048 8.70752C9.55019 8.14782 9.86462 7.3887 9.86462 6.59717C9.86462 5.80563 9.55019 5.04651 8.99048 4.48681C8.43078 3.92711 7.67166 3.61267 6.88013 3.61267ZM6.88013 8.38786C6.4052 8.38786 5.94973 8.1992 5.61391 7.86338C5.27809 7.52756 5.08943 7.07209 5.08943 6.59717C5.08943 6.12224 5.27809 5.66677 5.61391 5.33095C5.94973 4.99513 6.4052 4.80647 6.88013 4.80647C7.35505 4.80647 7.81052 4.99513 8.14634 5.33095C8.48216 5.66677 8.67082 6.12224 8.67082 6.59717C8.67082 7.07209 8.48216 7.52756 8.14634 7.86338C7.81052 8.1992 7.35505 8.38786 6.88013 8.38786Z"
                fill="white"
              /></svg
            >Retake</BaseButton
          >
          <BaseButton @click="done" class="button btn-primary large">Done</BaseButton>
        </div>
      </div>
      <div v-if="!imageCaptured" class="upload" :style="{ bottom: uploadBottom + 'px' }" @click="capture">
        <div>
          <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.6553 1.82197H9.76315L8.67082 0.628174H5.08943L3.9971 1.82197H2.10493C1.78832 1.82197 1.48467 1.94775 1.26079 2.17163C1.03691 2.39551 0.911133 2.69916 0.911133 3.01577V10.1786C0.911133 10.4952 1.03691 10.7988 1.26079 11.0227C1.48467 11.2466 1.78832 11.3724 2.10493 11.3724H11.6553C11.9719 11.3724 12.2756 11.2466 12.4995 11.0227C12.7233 10.7988 12.8491 10.4952 12.8491 10.1786V3.01577C12.8491 2.69916 12.7233 2.39551 12.4995 2.17163C12.2756 1.94775 11.9719 1.82197 11.6553 1.82197ZM11.6553 10.1786H2.10493V3.01577H4.52237L5.6147 1.82197H8.14555L9.23788 3.01577H11.6553V10.1786ZM6.88013 3.61267C6.08859 3.61267 5.32947 3.92711 4.76977 4.48681C4.21007 5.04651 3.89563 5.80563 3.89563 6.59717C3.89563 7.3887 4.21007 8.14782 4.76977 8.70752C5.32947 9.26723 6.08859 9.58166 6.88013 9.58166C7.67166 9.58166 8.43078 9.26723 8.99048 8.70752C9.55019 8.14782 9.86462 7.3887 9.86462 6.59717C9.86462 5.80563 9.55019 5.04651 8.99048 4.48681C8.43078 3.92711 7.67166 3.61267 6.88013 3.61267ZM6.88013 8.38786C6.4052 8.38786 5.94973 8.1992 5.61391 7.86338C5.27809 7.52756 5.08943 7.07209 5.08943 6.59717C5.08943 6.12224 5.27809 5.66677 5.61391 5.33095C5.94973 4.99513 6.4052 4.80647 6.88013 4.80647C7.35505 4.80647 7.81052 4.99513 8.14634 5.33095C8.48216 5.66677 8.67082 6.12224 8.67082 6.59717C8.67082 7.07209 8.48216 7.52756 8.14634 7.86338C7.81052 8.1992 7.35505 8.38786 6.88013 8.38786Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.page {
  margin: auto;
  position: relative;
  width: 400px;
  @media screen and (max-width: 900px) {
    width: 100%;
  }

  .images-view {
    height: fit-content;
    width: 100%;
  }
  .images-view-camera {
    align-items: center;
    background: white;
    border-radius: 8px;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    flex-grow: 1;
    height: 65vh;
    justify-content: center;
    margin-top: 56px;
    max-height: 70rem;
    overflow: auto;
    position: relative;
    width: 100%;
    @media screen and (max-width: 900px) {
      height: 75vh;
    }
    .camera-stream {
      border-radius: 8px;
      bottom: 0;
      height: 72%;
      left: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 25px;
      object-fit: cover;
      position: absolute;
      right: 0;
      top: 0;
      width: 80%;
      z-index: 100;
    }
    .upload {
      align-items: center;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      height: fit-content;
      justify-content: center;
      left: 0;
      position: fixed;
      right: 0;
      div {
        background-color: white;
        border: 1px #4059e1 solid;
        border-radius: 50%;
        cursor: pointer;
        height: 5.5rem;
        position: relative;
        width: 5.5rem;
        &::before {
          background-color: #4059e1;
          border-radius: 50%;
          bottom: 2px;
          content: '';
          left: 2px;
          position: absolute;
          right: 2px;
          top: 2px;
          z-index: 2;
        }
        svg {
          height: 17px;
          position: absolute;
          right: 18px;
          top: 17px;
          width: 17px;
          z-index: 300;
        }
      }
    }
    .actions {
      align-items: center;
      bottom: 20px;
      display: flex;
      flex-direction: column;
      left: 0;
      position: absolute;
      right: 0;
      width: 100%;
      span {
        font-size: 35px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      div {
        align-items: center;
        display: flex;
        justify-content: space-around;
        width: 100%;
        button {
          align-items: center;
          display: flex;
          height: 50px;
          justify-content: center;
          width: 130px;
          svg {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .progress-bar {
    left: 40px;
    position: absolute;
    right: 40px;
    top: 40px;
  }

  .container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 65vh;
    justify-content: flex-start;
    margin-top: 56px;
    max-height: 70rem;
    overflow: auto;
    padding-bottom: 11rem;
    position: relative;
    width: 100%;
    .header {
      height: 240px;
      margin-bottom: 20px;
      text-align: start;
      width: 100%;

      .title {
        h1 {
          font-family: $base-font-family;
          font-size: 36px;
          font-style: normal;
          font-weight: 800;
          line-height: 42px;
          margin: 0 auto 0;
          margin-bottom: 20px;
          padding-top: 60px;
          width: 90%;
        }
      }

      .subtitle {
        color: black;
        font-family: $secondary-font-family;
        font-size: 16px;
        margin: 0;
        width: 100%;

        p {
          line-height: 1.38;
          margin: 0;
          margin-top: 3.25%;
          padding: 0 15px 0 15px;
        }
      }
    }

    .form {
      margin: 0;
      text-align: center;
      width: 100%;

      form {
        ::v-deep label {
          font-family: $proxima-nova;
          font-weight: 600;
        }
        ::v-deep input {
          font-family: $proxima-nova;
          font-weight: normal;
          &::placeholder {
            font-family: $proxima-nova;
            font-weight: normal;
          }
        }
        .header {
          margin: 0 auto;
          width: 90%;
        }
        .photos {
          padding: 0 15px 0 15px;
          .row {
            margin-left: unset;
            margin-right: unset;
          }
          .skip {
            align-items: center;
            cursor: pointer;
            display: flex;
            font-size: 17px;
            font-weight: 700;
            justify-content: flex-start;
            width: fit-content;
            svg {
              margin-left: 10px;
            }
          }
          .photos-wrapper {
            align-items: center;
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            .col {
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              padding-left: unset;
              padding-right: unset;
              width: fit-content;
              &:nth-child(2) {
                margin-left: 8px;
                margin-right: 8px;
              }
              img {
                border-radius: 12px;
                height: 135px;
                object-fit: cover;
                width: 100%;
              }
              .img {
                background-color: #cecece;
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 12px;
                height: 135px;
                width: 100%;
                .upload {
                  align-items: center;
                  display: flex;
                  flex-direction: column;
                  height: 100%;
                  justify-content: center;
                  div {
                    background-color: white;
                    border: 1px #4059e1 solid;
                    border-radius: 50%;
                    cursor: pointer;
                    height: 5.5rem;
                    position: relative;
                    width: 5.5rem;
                    &::before {
                      background-color: #4059e1;
                      border-radius: 50%;
                      bottom: 2px;
                      content: '';
                      left: 2px;
                      position: absolute;
                      right: 2px;
                      top: 2px;
                      z-index: 2;
                    }

                    svg {
                      height: 17px;
                      position: absolute;
                      right: 18px;
                      top: 17px;
                      width: 17px;
                      z-index: 300;
                    }
                    &:hover {
                      &::before {
                        background-color: darken(#4059e1, 5);
                      }
                    }
                  }
                  span {
                    color: #4059e1;
                    cursor: pointer;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: bold;
                    letter-spacing: -0.761905px;
                    margin-top: 10px;
                    text-align: center;
                    &.noCam {
                      font-size: 18px;
                      margin-top: unset;
                    }
                    &:hover {
                      color: darken(#4059e1, 5);
                    }
                  }
                }
                .remove {
                  align-items: center;
                  background-color: #4059e1;
                  border: 1px white solid;
                  border-radius: 50%;
                  cursor: pointer;
                  display: flex;
                  justify-content: center;
                  opacity: 1;
                  padding: 5px;
                  position: absolute;
                  right: -4px;
                  top: -5px;
                }
              }
              span {
                color: #bdbdbd;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                letter-spacing: 0.161905px;
                margin-top: 5px;
                &.haveImg {
                  color: #4059e1;
                }
              }
            }
          }
        }
      }
    }
  }
  .buttons {
    background-color: white;
    border-radius: 8px;
    bottom: 0;
    float: right;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 10;
    #next {
      float: right;
      margin-bottom: 20px;
      margin-left: auto;
      margin-right: 5%;
      width: 40%;
      button:disabled {
        background-color: lighten($color: #4059e1, $amount: 20);
      }
    }
    #back {
      display: flex;
      flex-direction: column;
      float: left;
      margin: 0;
      margin-right: auto;
      width: 28%;
      button {
        border: unset;
      }
      .large-transparent {
        color: #000;
      }
    }
  }
  &.isMobile {
    height: 100%;
    padding-top: 40px;
    width: 100%;
    .base-progress-bar {
      margin-left: 6.4%;
      width: 87.2%;
    }
    .container {
      box-shadow: unset;
      height: unset;
    }
  }
}
</style>
